import { useState } from "react";

export default function Section10() {
    const [isOpen, setIsOpen] = useState(new Array(9).fill(false));

    const handleFaq = (index) => {
        setIsOpen((prevState) =>
            prevState.map((item, idx) => (idx === index ? !item : false))
        );
    };

    const faqs = [
        {
            question: "Why is TikTok advertising essential for businesses today?",
            answer:
                "TikTok reaches over a billion monthly users worldwide and offers brands access to highly engaged audiences that many traditional platforms cannot reach. For fast-moving sectors like retail, entertainment, e-commerce and consumer services, TikTok provides a platform where brand awareness, engagement and conversions can grow rapidly."
        },
        {
            question: "What types of ad content work best on TikTok globally?",
            answer:
                "Top-performing TikTok ads typically follow these characteristics:\n" +
                "- A strong hook in the first 2-3 seconds to stop the scroll.\n" +
                "- Mobile-first, vertical format visuals with sound, trending music or effects.\n" +
                "- Authentic creator-led or influencer-driven content rather than overly polished ads.\n" +
                "- Clear call to action and optimized landing experience for conversion.\n" +
                "- Localization and relevance to the target market’s language, culture and habits."
        },
        {
            question: "Do TikTok ads need to be localized for different markets?",
            answer:
                "Yes. While TikTok is global, audience behavior, language and culture differ across markets. Successful campaigns adapt visuals, audio, language (subtitles or voice-over), and local trends to resonate. For example, if targeting Arabic-speaking regions, Arabic content boosts trust and engagement. For other regions, content should reflect local language, cultural norms and platform usage patterns."
        },
        {
            question: "How precise is TikTok’s ad targeting and global reach?",
            answer:
                "TikTok’s ad platform supports detailed targeting by demographics, interests, behaviours, location, device-type, and custom audiences. The platform’s global ad reach is estimated at approximately 1.9 billion users in 2025. This makes TikTok a viable channel for both regional campaigns and multi-market roll-outs."
        },
        {
            question: "What performance benchmarks and ROI can brands expect from TikTok advertising?",
            answer:
                "Recent data indicates that average conversion rates for TikTok ads are between 1.1% and 2.4%. Cost per thousand impressions (CPM) remains competitive, with one benchmark at around US $7.03 CPM in Q1 2025. Additionally, brands that launch branded hashtag challenges can see strong return on ad spend (ROAS) and in some cases 2.5× or more."
        },
        {
            question: "What’s included in your TikTok Ads Management service?",
            answer:
                "Our TikTok Ads Management includes full campaign setup, creative production, audience targeting, daily optimization, performance tracking, and reporting. We handle everything from concept to conversion so your campaigns deliver consistent results."
        },
        {
            question: "How do you measure success in TikTok advertising campaigns?",
            answer:
                "Key metrics include:\n" +
                "- Engagement rate (likes, comments, shares)\n" +
                "- View-through rate (how many viewers watch the ad entirely)\n" +
                "- Click-through rate (CTR) and cost per click (CPC)\n" +
                "- Conversion rate (sales, sign-ups, downloads) and cost per acquisition (CPA)\n" +
                "- Return on ad spend (ROAS) and revenue per viewer\n" +
                "TikTok’s analytics tools combined with custom dashboards allow transparency and optimization based on real-time data."
        },
        {
            question: "What industries are best suited for TikTok campaigns?",
            answer:
                "While any business with an online audience can benefit, TikTok performs particularly well for:\n" +
                "- E-commerce brands and retail (especially impulse-buy products)\n" +
                "- Lifestyle, fashion, beauty, food & beverage industries.\n" +
                "- Consumer services, apps and direct-to-consumer models.\n" +
                "- Brands targeting younger demographics (Gen Z, Millennials) but also expanding to broader audiences."
        },
        {
            question: "Is TikTok advertising accessible for smaller budgets or global brands alike?",
            answer:
                "Yes. TikTok provides flexible budget options and diverse ad formats, making it accessible for smaller brands and global enterprises. The platform’s affordability in terms of CPM compared with other major social networks makes it appealing for a wide range of marketers."
        }
    ];



    return (
        <div className="w-full Section8 mt-[12%] md:mt-[4%]">
            <div className="w-full section8-container">
                <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
                    <h2 className="leading-[29px] md:leading-[41px] text-[26px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
                        Frequently Asked Questions About TikTok Marketing
                    </h2>
                </div>

                <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
                            style={{
                                background:
                                    "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
                            }}
                        >
                            <div
                                onClick={() => handleFaq(index)}
                                className="question text-[#444444] cursor-pointer flex justify-between items-center"
                            >
                                {faq.question}
                                <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[index] ? "-" : "+"}</b>
                            </div>
                            <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444"]`}>
                                <br />
                                {faq.answer.includes("-") ? (
                                    <>
                                        {/* Intro line */}
                                        <p className="mb-2">{faq.answer.split("\n")[0]}</p>

                                        {/* Bullet points */}
                                        <ul className="list-disc pl-5 mb-5 space-y-1">
                                            {faq.answer
                                                .split("\n")
                                                .slice(1) // skip the first line
                                                .map((line, idx) => {
                                                    const trimmed = line.trim();
                                                    if (!trimmed) return null;
                                                    return <li key={idx}>{trimmed.replace(/^- /, "")}</li>;
                                                })}
                                        </ul>
                                    </>
                                ) : (
                                    <p className="mb-5">{faq.answer}</p>
                                )}
                            </div>


                        </div>
                    ))}
                </div>
            </div>

            <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
